import { useEffect, useState } from "react";
import { VscClose } from "react-icons/vsc";
import { RxHamburgerMenu } from "react-icons/rx";
import { scroller } from "react-scroll";

const Header = () => {
  const [header, setHeader] = useState("header-top");
  const [openNavigation, setOpenNavigation] = useState(false);

  const onChangePage = (route) => {
    scroller.scrollTo(route, {
      duration: 1000,
      delay: 0,
      smooth: "easeInOutQuart",
    });
  };

  const listenScrollEvent = () => {
    if (window.scrollY < 100) {
      return setHeader("header-top");
    } else if (window.scrollY >= 100) {
      return setHeader("header");
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", listenScrollEvent);

    return () => window.removeEventListener("scroll", listenScrollEvent);
  }, []);

  return (
    <div>
      <div className={header}>
        <div className="header_logo">
          <a href="/">
            <img src="/images/logo.png" alt="Triotim Homepage" />
          </a>
        </div>

        <div className="header_navigation">
          <div>
            <a href="/">Početna</a>
          </div>
          <div onClick={() => onChangePage("o-nama")}>
            <a className="production-button">O Nama</a>
          </div>
          <div onClick={() => onChangePage("usluge")}>
            <a>Usluge</a>
          </div>
          <div onClick={() => onChangePage("licence")}>
            <a>Licence</a>
          </div>
          <div onClick={() => onChangePage("licence")}>
            <a>Ovlašćenje</a>
          </div>
          <div onClick={() => onChangePage("nas-tim")}>
            <a>Naš tim</a>
          </div>
          <div onClick={() => onChangePage("karijera")}>
            <a>Karijera</a>
          </div>
          {/* <div onClick={() => onChangePage("contact")} key={"contact"}>
            <div className="contact-header">Kontakt</div>
          </div> */}
        </div>
      </div>

      <div className={`${header}-mobile ${openNavigation ? "no-padding" : ""}`}>
        <div className="header_logo">
          <a href="/">
            <img src="/images/logo.png" alt="Triotim Homepage" />
          </a>
        </div>
        <div
          className="header_navigation-hamburger"
          onClick={() => setOpenNavigation(true)}
        >
          <RxHamburgerMenu />
        </div>

        {openNavigation && (
          <div className="header_navigation-mobile">
            <div
              className="header_navigation-mobile-close"
              onClick={() => setOpenNavigation(false)}
            >
              <VscClose />
            </div>
            <div className="header-navigation-content-mobile">
              <div>
                <a href="/">Početna</a>
              </div>
              <div onClick={() => onChangePage("o-nama")}>
                <a className="production-button-mobile">O Nama</a>
              </div>
              <div onClick={() => onChangePage("usluge")}>
                <a>Usluge</a>
              </div>
              <div onClick={() => onChangePage("licence")}>
                <a>Licence</a>
              </div>
              <div onClick={() => onChangePage("licence")}>
                <a>Ovlašćenje</a>
              </div>
              <div onClick={() => onChangePage("nas-tim")}>
                <a>Naš tim</a>
              </div>
              <div onClick={() => onChangePage("karijera")}>
                <a>Karijera</a>
              </div>
              {/* <div
                style={{
                  paddingBottom: "6vh",
                }}
                onClick={() => onChangePage("contact")}
                key={"contact"}
              >
                <div className="contact-header">Kontakt</div>
              </div> */}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Header;
